/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumerateResourcesRequest
 */
export interface EnumerateResourcesRequest {
    /**
     * RID of the resource under which to enumerate resources
     * @type {string}
     * @memberof EnumerateResourcesRequest
     */
    containerRID: string;
}

/**
 * Check if a given object implements the EnumerateResourcesRequest interface.
 */
export function instanceOfEnumerateResourcesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "containerRID" in value;

    return isInstance;
}

export function EnumerateResourcesRequestFromJSON(json: any): EnumerateResourcesRequest {
    return EnumerateResourcesRequestFromJSONTyped(json, false);
}

export function EnumerateResourcesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerateResourcesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'containerRID': json['containerRID'],
    };
}

export function EnumerateResourcesRequestToJSON(value?: EnumerateResourcesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'containerRID': value.containerRID,
    };
}

